var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-col',{attrs:{"span":11,"offset":4}},[_c('Table',{attrs:{"dataList":_vm.dataList}})],1),_c('el-col',{attrs:{"span":4,"offset":1}},[_c('Recomm')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }